export function fun_load_theme(_v) {
  const tb_theme_default = () => import('@/assets/styles/theme/tb_theme_default.css');
  const tb_theme_red = () => import('@/assets/styles/theme/tb_theme_red.css');
  const tb_theme_blue = () => import('@/assets/styles/theme/tb_theme_blue.css');
  const tb_theme_dark = () => import('@/assets/styles/theme/tb_theme_dark.css');

  const tlr_theme_default = () => import('@/assets/styles/theme/tlr_theme_default.css');
  const tlr_theme_red = () =>     import('@/assets/styles/theme/tlr_theme_red.css');
  const tlr_theme_blue = () =>    import('@/assets/styles/theme/tlr_theme_blue.css');
  const tlr_theme_dark = () =>    import('@/assets/styles/theme/tlr_theme_dark.css');

  if(_v=='tb_theme_default') tb_theme_default()
  if(_v=='tb_theme_red') tb_theme_red()
  if(_v=='tb_theme_blue') tb_theme_blue()
  if(_v=='tb_theme_dark') tb_theme_dark()

  if(_v=='tlr_theme_default') tlr_theme_default()
  if(_v=='tlr_theme_red') tlr_theme_red()
  if(_v=='tlr_theme_blue') tlr_theme_blue()
  if(_v=='tlr_theme_dark') tlr_theme_dark()
}

export function fun_convert_to_string(obj) {
  var convertedObj = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        convertedObj[key] = convertObjectToString(obj[key]);
      } else {
        convertedObj[key] = String(obj[key]);
      }
    }
  }

  return convertedObj;
}

export function fun_save_dict(_v){
  localStorage.setItem('DICT',JSON.stringify(_v));
}
export function fun_get_dict(_k){
  let dict = localStorage.getItem('DICT')+'';
  if (!dict.startsWith('[')) return [];
  dict = JSON.parse(dict);
  const res = [];
  dict.forEach(n=>{
    if(_k==n.dictKey) res.push(n);
  })
  return res;
}